export const studentStatus = {
  UNASSIGNED: 0,
  UNATTEMPTED: 1,
  ASSIGN_SELECTION: 2,
  PARTIAL: 3,
  CORRECT: 4,
  UNASSIGN_SELECTION: 6
};

export const teacherStatus = {
  SUBMITTED: 1,
  REVIEWED: 2
};

export const assignmentType = {
  RESTRICTED: 0,
  NON_RESTRICTED: 1
};

export const MAX_STUDENT_NAME_LENGTH = 30;
export const MAX_ITEMS_TO_DISPLAY = 14;
export const MAX_GROUP_NAME_LENGTH = 20;
export const MAX_LEARNING_JOURNEY_COUNT = 200;
export const LOCALE_DEFAULT = 'en-AU';
export const MAX_STUDENT_NAME_LENGTH_CONTEXT = 100;
export const MAX_STUDENT_GRADE_LENGTH = 50;

export const assignmentFilterType = {
  ASSIGN_UPF: 0,
  ASSIGN_LEARNING_GAPS: 1,
  VOLUNTARY: 2
};

export const ACCURACY = 'accuracy';

export const SORT_DIRECTION_TYPES = {
  DESC: 'desc',
  ASC: 'asc'
};

export const ASSIGNMENT_RESULT_TYPES = {
  HIGHEST: 0,
  ASSIGNED: 1,
  VOLUNTARY: 2
};

export const TOPICS_TYPES = {
  STANDARD: 'standard',
  STRAND: 'strand'
};

export const SEARCH_PARAMS = {
  COUNTRY_CODE_PARAM: 'countryCode',
  REGION_CODE_PARAM: 'regionId'
};

export const LOCAL_STORAGE_KEYS = {
  LAST_USED_PUBLICATION: 'LAST_USED_PUBLICATION',
  LAST_USED_COURSE: 'LAST_USED_COURSE',
  LAST_USED_CLASSROOM: 'LAST_USED_CLASSROOM',
  LAST_USED_GROUP: 'LAST_USED_GROUP',
  ACCURACY_PROGRESS_FILTER: 'ACCURACY_PROGRESS_FILTER'
};

export const REGION_IDS = {
  AUSTRALIA: '8',
  NEW_ZEALAND: '14'
}



// WEBPACK FOOTER //
// ./helpers/constants.js